import { createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from '@/shared/api/instance';
import type { AuthResponse, ErrorResponse, LoginTelegramParams } from '../api/auth.types';

export const loginTelegram = createAsyncThunk<
  AuthResponse,
  LoginTelegramParams,
  { rejectValue: ErrorResponse }
>('auth/loginTelegram', async (params, thunkAPI) => {
  try {
    const response = await axiosInstance.post<AuthResponse>('/app/login/telegram', params, {});
    return response.data;
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error);
  }
});
